// removed by extract-text-webpack-plugin
module.exports = {"component":"_1JPnS-wCE-8dL4C0x0BASQ","border":"_2bH0JxowQXmXyJG8wvUFsz","jsdd":"_1KsQWwTRmQcpUafV31fxTX","larbox":"_2j7vIM_13JoKWo02SzfdpR","icona":"_1nrXY5z6ucXtzMDiR1RuPd","menu":"_3P51MLlmPJuBooX41NzoDh","selt":"xzc3SLPrTfPoP9NYyptRp","jsallshou":"_3iBVeScCtgcOVG-NzxJEkW","allTable":"_1s8zAB_fcAB6dHQqh1o_c7","bttn":"_1BLHBKDJLGUty0llNlT136"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopSelling/ExperienceShopSelling.scss
 ** module id = 1066
 ** module chunks = 0
 **/